import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { OpsappService } from '../../services/opsapp.service';
import { CookieService } from 'ngx-cookie';


@Component({
  selector: 'app-worklist',
  templateUrl: './worklist.component.html',
  styleUrls: ['./worklist.component.css']
})
export class WorklistComponent {
  documentStyle: any;

  loading: boolean = true;
  worklist: any;
  worklistDetails: any;
  imageModal: boolean = false;
  graphModal: boolean = false;
  retestModal: boolean = false;
  submitWait: boolean = false;

  limsLoginModal: boolean = false;
  username: string;
  password: string;
  currentLimsToken: any;

  labels: any;
  rawData: any;
  chartData: {};
  options: {};
  probes: any;
  selectedProbe: any;

  selectedPlate: any;

  retestTypes: string[] = ["Destination", "Source"];
  selectedRetestType: any;
  retestReasons: any;
  selectedRetestReason: any;

  constructor(private opsappService: OpsappService, 
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private cookieService: CookieService){}

  ngOnInit(){
    this.documentStyle = getComputedStyle(document.documentElement);
    this.setChartOptions();
    this.loadData();
  }

  loadData(){
    this.loading = true;
    this.opsappService.activeWorklist.pipe(first()).subscribe(data => {
      if (data == undefined || data == null)
        this.goToList();
      else
      {
        this.worklist = data;
        var worklistOptions = {
          WorklistId: data.worklistId,
          Barcode: data.searchedBarcode
        }
        this.opsappService.getWorklist(worklistOptions).then(data => {
          this.worklistDetails = data;
          console.log(this.worklistDetails);
          this.loading = false;
        });
      }
    });
  }

  loadRetestReasons(){
    this.opsappService.getRetestReasons(this.currentLimsToken).then(data => {
      this.retestReasons = data;
      this.retestReasons.sort(this.sortRetestReasons);
    });
  }

  goToList(){
    this.router.navigate(["worklist-list"], { relativeTo: this.route.parent });
  }

  getGroupTypeName(plate: any){
    if (plate.barcodeText.startsWith("T"))
      return "Source"
    else if (plate.barcodeText.startsWith("D"))
      return "Destination"
    else if (plate.barcodeText.startsWith("A"))
      return "ABI"
    else
      return "Unknown Plate Type"
  }

  showImage(plate: any){
    this.selectedPlate = plate;
    this.imageModal = true;
  }

  showChart(plate: any){
    this.getPlateCharts(plate);
  }

  setChartOptions(){
    this.options = {
      responsive:true,
      maintainAspectRatio: true,
      aspectRatio: .7,
      resizeDelay: 500,
      elements: {
        point:{
            radius: 0
        }
      },
      scales: {
        y: {
          type: 'logarithmic',
          position: 'right',
          min: .01,
          max: 10,
          grid: {
            color: this.graphLineColorFunction,
            lineWidth: this.graphLineWidthFunction
          }
        },
        x: {
          grid: {
            color: this.graphLineColorFunction
          }
        }
      },
      plugins: {
        legend: {
          display: false
        }
      }
    };
  }

  graphLineColorFunction(context:any){
    var docStyle = getComputedStyle(document.documentElement);
    if (context.tick.value == .1)
      return docStyle.getPropertyValue('--text-color');
    else
      return docStyle.getPropertyValue('--text-color-secondary');
  }

  graphLineWidthFunction(context:any){
    if (context.tick.value == .1)
      return 3;
    else
      return 1;
  }

  getPlateCharts(plate: any){
    this.selectedPlate = plate;
    this.rawData = null;
    this.probeChanged("");
    this.graphModal = true;
    this.opsappService.getPlateChart(plate.barcodeText).then(data => {
      this.rawData = data;
      var probeArray = data.map((result: any) => {
        return result.reporter;
      });
      this.probes = this.uniqueArray(probeArray);
      this.probes.unshift("All")
      this.selectedProbe = this.probes[0];
      this.probeChanged(this.selectedProbe);
    });
  }

  filterArrByProbe(arr: [], probe: string){
    return arr.filter((el: any) => el.reporter == probe);
  }

  filterKeyArr(arr: string[]){
    return arr.filter((el: any) => el.includes("deltaRN") && el != "deltaRNSum");
  }

  probeChanged(probe: string){
    
    var datasets: {}[] = [];
    var colorIndex = 0;
    if (probe=="All")
    {
      this.probes.slice(1).forEach((eachProbe: string) => {
        if (eachProbe == "001" || eachProbe == "001RN" || eachProbe == "SNP WT" 
          || eachProbe == "001RNVIC" || eachProbe == "001VIC")
          datasets.push(this.getProbeGraphDataset(eachProbe, this.documentStyle.getPropertyValue('--text-color')));
        else{
          datasets.push(this.getProbeGraphDataset(eachProbe, this.getRandomColor()));
          colorIndex++;
        }
      });
    }
    else if (probe == "001" || probe == "001RN" || probe == "SNP WT" 
      || probe == "001RNVIC" || probe == "001VIC")
      datasets.push(this.getProbeGraphDataset(probe, this.documentStyle.getPropertyValue('--text-color')));
    else if (probe == "")
      datasets = [];
    else
      datasets.push(this.getProbeGraphDataset(probe, this.getRandomColor()));
    
    console.log(datasets);
    if (datasets.length > 0)
    {
      var chartLabels = this.labels.map((x:any) => x.substring(7, 9))
      this.chartData = {labels: chartLabels, datasets: datasets.flat()};
    }
    else{
      this.chartData = {};
    }

  }

  getProbeGraphDataset(probe: string, color: string){
    var datasets: {}[] = [];
    var probeData = this.filterArrByProbe(this.rawData, probe);
    console.log(probe);
    var keys = Object.keys(probeData[0]);
    this.labels =  this.filterKeyArr(keys);

    probeData.map((x:any) => {
      var resultData:any[] = [];
      this.labels.forEach((label: string) => {
        resultData.push(x[label])
      });
      var result = {label: x.well, data: resultData, tension: .4, borderWidth: 1, 
        borderColor: color};
      datasets.push(result);
    });
    return datasets;
  }

  showRetest(plate: any){
    this.selectedPlate = plate;
    this.retestModal = true;
    this.getUserToken();
    this.loadRetestReasons();
  }

  submitRetest(){
    this.submitWait = true;
    var retestOptions= {
      Token: this.currentLimsToken,
      PlateBarcode: this.selectedPlate.barcodeText,
      RetestType: this.selectedRetestType,
      RetestReason: this.selectedRetestReason.name
    };

    this.opsappService.submitRetest(retestOptions).then(data => {
      if (data == "")
      {
        this.messageService.add({severity:'success', summary: this.selectedPlate.barcodeText + ' Retest created successfully.', life: 10000});
        this.retestModal = false;
        this.submitWait = false;
      }
      else
        this.messageService.add({severity:'error', summary: data, life: 10000});
        this.submitWait = false;
    });
  }
  
  uniqueArray(a: any) {
    return [...new Set(a)];
  }

  clearUserToken(){
    this.opsappService.limsToken.next(null);
    this.currentLimsToken = null;
  }

  addUserToken(token: any){
    this.setLimsTokenCookie(token);
    this.opsappService.limsToken.next(token);
    this.currentLimsToken = token;
  }

  getUserToken(){
    this.opsappService.limsToken.pipe(first()).subscribe(token => {
      if (token == null){
        this.getLimsTokenCookie();
      }
      else
      {
        this.currentLimsToken = token;
      }
    });
  }

  getLimsTokenCookie(){
    var token = this.cookieService.get("limsToken");
    if (token != undefined)
      this.addUserToken(token)
    else
      this.limsLoginModal = true;
  }

  setLimsTokenCookie(token: string){
    this.cookieService.put("limsToken", token);
  }

  loginModalSubmit(){
    this.submitWait = true;
    var basicAuthOptions = {
      UserName: this.username,
      Password: this.password
    }

    this.opsappService.getLimsToken(basicAuthOptions).then(data => 
      {
        if (data == "error")
        {
          this.messageService.add({severity:'error', summary: "Could not log in to Lims."});
          this.submitWait = false;
        }
        else{
          this.addUserToken(data);
          this.limsLoginModal = false;
          this.submitWait = false;
          //need this here in case we didn't have the token on page load
          this.loadRetestReasons();
        }
      })
  }
  
  getRandomColor() {
    var length = 6;
    var chars = '0123456789ABCDEF';
    var hex = '#';
    while (length--) hex += chars[(Math.random() * 16) | 0];
    return hex;
  }

  sortRetestReasons(a:any, b:any){
    var nameA = a.description.toLowerCase();
    var nameB = b.description.toLowerCase();
    var isAOperational = nameA.includes("operational problem");
    var isBOperational = nameB.includes("operational problem");
    if (nameA === nameB) return 0;
    else if (isAOperational && !isBOperational) return -1;
    else if (isBOperational && !isAOperational) return 1;
    else if (nameA > nameB) return 1;
    else return -1
  }
}
